import React from "react";
import "./DecentralizedHero.css";
import '../Decentralizedcommon.css';
import mainimage from "../decentassets/mainimg.png";

export default function DecentralizedHero() {
    const counters = [
    {
      value: "50+",
      text: "Years Working in Blockchain",
    },
    {
      value: "100+",
      text: "Employees",
    },
    {
      value: "99.9%",
      text: "Projects",
    },
    {
      value:"15+",
      text:"Years of Experience",
    }
  ];

  const Counter = ({ className }) => (
    <div className={`counter ${className}`}>
      {counters.map((item, index) => (
        <div className="count" key={index}>
          <h2>{item.value}</h2>
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div id="decentralized-hero" className="dappmainclass">
   <div className="hero">
       <div className="left">
      <div className="content">
          <h1>Build Secure, Scalable Decentralized Applications for Web3 Growth</h1>
        <p>
      Accelerate your Web3 growth with our secure, scalable dApp development services, tailored for businesses and real-world use cases. </p>
      </div>
       <Counter className="desktop-counter" />
      </div>
      <div className="right">
        <img src={mainimage} alt="error" />
      </div>
   </div>
   <Counter className="mobile-counter" />
    </div>
  );
}
